import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PROCEDURES } from "../data/site";

export default function AdvancedProcedures({ headingTag: Tag = "h3" }) {
  return (
    <section
      id="procedures"
      data-testid="procedures-section"
      className="section-pad"
    >
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="overline">Advanced Procedures</div>
            <Tag className="font-serif-display mt-4 text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
              Endoscopy &amp; Therapeutic GI Procedures in Varanasi.
            </Tag>
          </div>
          <p className="text-black/65 max-w-md text-[15px] leading-relaxed">
            Every procedure is performed by Dr. Dixit personally, with calibrated
            sedation, modern HD scopes and a focused recovery protocol.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {PROCEDURES.map((p, i) => (
            <Link
              key={p.slug}
              to={`/procedures/${p.slug}`}
              data-testid={`procedure-card-${p.slug}`}
              className="group edit-card flex flex-col"
            >
              <div className="flex items-center justify-between">
                <span className="text-[11px] tracking-[0.2em] uppercase text-[#0370AD] font-semibold">
                  Procedure · {String(i + 1).padStart(2, "0")}
                </span>
                <span className="text-[11px] tracking-[0.18em] uppercase text-black/55">
                  {p.duration}
                </span>
              </div>
              <h4 className="mt-6 font-display-semibold text-2xl md:text-[26px] leading-tight">
                {p.title}
              </h4>
              <p className="mt-4 text-[14px] text-black/65 leading-relaxed">
                {p.summary}
              </p>
              <div className="mt-8 pt-5 border-t border-black/10 flex items-center justify-between">
                <span className="text-[13px] font-semibold">Learn more</span>
                <ArrowUpRight className="h-4 w-4 arrow text-[#0370AD]" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
